import {ActivitiesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'UPDATE_ACTIVITY';

export async function updateActivity(token: string, activityId: number | string, payload: Record<string, unknown>) {
    try {
        const result = await ActivitiesDao.updateActivity(token, activityId, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour de l\'activité',
            error: error
        });
    }
}
